module.exports = __webpack_public_path__ + "static/media/qoo10_logo.470bd6b4.png";